export const profile = {
	path: "/profile",
	component: null,
	children: [
		{
			path: "",
			name: "profile.index",
			component: () =>
				import(
					/* webpackChunkName: "profileview" */ "../views/Profile/index.vue"
				)
		},
		{
			path: "/edit",
			name: "profile.edit",
			component: () =>
				import(
					/* webpackChunkName: "profileedit" */ "../views/Profile/edit.vue"
				)
		}
	]
};
